import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class PaymentOptionPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.paymentOptionRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.paymentOptionImport,
    );
    this.paymentOptionAutocomplete = permissionChecker.match(
      Permissions.values.paymentOptionAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.paymentOptionCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.paymentOptionEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.paymentOptionDestroy,
    );
  }
}
